module.exports = __webpack_public_path__ + "img/slide_r.c120f8f6.svg";